import React from 'react';

interface ConfirmDeleteNoteModalProps {
    isDeleting: boolean;
    onClose: () => void;
    onConfirm: () => void;
}

// Same look and copy conventions as ConfirmCancelModal.tsx (destructive red
// confirm, quiet "Keep it" cancel). Only shown for a PERSISTED note
// (linkedNoteId set); an unsaved one is cleared locally with no confirm.
const ConfirmDeleteNoteModal: React.FC<ConfirmDeleteNoteModalProps> = ({
    isDeleting,
    onClose,
    onConfirm
}) => (
    <div
        className="fixed inset-0 z-50 flex items-center justify-center p-6 bg-gray-900/25"
        onMouseDown={(e) => e.target === e.currentTarget && onClose()}
    >
        <div className="w-full max-w-sm rounded-xl border border-gray-200 bg-white shadow-xl">
            <div className="p-6">
                <h2 className="text-base font-semibold text-gray-800">Delete this chart note?</h2>
                <p className="text-sm text-gray-500 mt-2 leading-relaxed">
                    This removes it from the appointment and from the patient&rsquo;s Notes tab.
                    This can&rsquo;t be undone.
                </p>
                <div className="flex justify-end gap-2 mt-6">
                    <button
                        type="button"
                        onClick={onClose}
                        disabled={isDeleting}
                        className="rounded-lg border border-gray-200 px-4 py-2.5 text-sm font-medium text-gray-600 hover:bg-gray-50 disabled:opacity-50"
                    >
                        Keep it
                    </button>
                    <button
                        type="button"
                        onClick={onConfirm}
                        disabled={isDeleting}
                        className="rounded-lg bg-red-600 px-4 py-2.5 text-sm font-medium text-white hover:bg-red-700 disabled:opacity-50"
                    >
                        Delete note
                    </button>
                </div>
            </div>
        </div>
    </div>
);

export default ConfirmDeleteNoteModal;
